import { WORKLOAD_CATEGORIES, WORKLOAD_VIEWS } from './_constants';
import type { WorkloadCategory, WorkloadView } from './_constants';

const ALL_CATEGORIES = Object.values(WORKLOAD_CATEGORIES);

const isWorkloadsCategory = (
  value: string | undefined
): value is WorkloadCategory =>
  ALL_CATEGORIES.includes(value as WorkloadCategory);

const isWorkloadView = (value: string | undefined): value is WorkloadView =>
  value === WORKLOAD_VIEWS.LIST ||
  value === WORKLOAD_VIEWS.DASHBOARD ||
  value === WORKLOAD_VIEWS.VERTICAL_AUTOSCALING ||
  value === WORKLOAD_VIEWS.HORIZONTAL_AUTOSCALING ||
  value === WORKLOAD_VIEWS.META ||
  value === WORKLOAD_VIEWS.EVENTS;

export const getWorkloadsViewFromPathname = (
  pathname: string
): WorkloadView => {
  const segments = pathname.split('/').filter(Boolean);
  const workloadsIndex = segments.indexOf('workloads');

  if (workloadsIndex === -1) {
    return WORKLOAD_VIEWS.DASHBOARD;
  }

  const nextSegment = segments[workloadsIndex + 1];

  // Cluster-level: /.../workloads/:view/:category?
  if (isWorkloadView(nextSegment)) {
    return nextSegment;
  }

  // Workload-scoped: /.../workloads/:workloadId/:view/:category?
  const viewSegment = segments[workloadsIndex + 2];

  if (isWorkloadView(viewSegment)) {
    return viewSegment;
  }

  return WORKLOAD_VIEWS.DASHBOARD;
};

export const getWorkloadsCategoryFromPathname = (
  pathname: string
): WorkloadCategory | undefined => {
  const lastSegment = pathname.split('/').pop();

  return isWorkloadsCategory(lastSegment) ? lastSegment : undefined;
};

// Read window.location.search directly because SearchProvider writes filter
// state via setQueryParamSilently (window.history.replaceState), which does
// not fire popstate and is invisible to React Router's useSearchParams.
export const getLiveSearchParams = (): URLSearchParams =>
  new URLSearchParams(window.location.search);
